module.exports = __webpack_public_path__ + "components/rewards/sport-pursuit/static/icon-0601b5e675e3b9f1f5e9d06f05c78301.svg";